export const getDataToken = async (token: any) => {
    try {
        const data = await fetch(`${process.env.REACT_APP_API_URL}/token_cita/obtener?token_cita=${token}`);
        const JsonData = await data.json();
        return JsonData.respuesta;
    } catch (error) {
        return error;
    }
};